/** The opt-out field of the user's private `performance` config; other fields pass through untouched */
export interface NotPerformingConfig {
  notPerformingBands?: string[]
}

/**
 * "I don't perform with {Band}": stored per band in the member's private config, projected to bandmates only through
 * the band-scoped band-parts endpoint (plan, Decision 1). Reversible from the same place.
 */
export const setNotPerforming = <C extends NotPerformingConfig>(
  config: C | undefined,
  bandId: string,
  notPerforming: boolean
): C => {
  const { notPerformingBands, ...rest } = config ?? ({} as C)
  const others = (notPerformingBands ?? []).filter(id => id !== bandId)
  const next = notPerforming ? [...others, bandId] : others
  return (next.length > 0 ? { ...rest, notPerformingBands: next } : rest) as C
}
